import enterView from 'enter-view';
import jump from 'jump.js';

Alpine.data('takeAction', (endpoint, hideAtAnchorLink, minCount = 0) => ({
	petitionCount: minCount,
	hideInAPPBrowser: false,

	init() {
		this.handleEnterView();
		MicroModal.init();

		this.getCount();

		// Check if use is using an in-app browser on iphone
		const ua = navigator.userAgent || window.opera;
		const isInstagram = ua.indexOf('Instagram') > -1;
		const isFacebook = navigator.userAgent.match(/FBAN|FBAV/i);
		const isIphone = ua.indexOf('iPhone') > -1;

		// If user is using an in-app browser on iphone, hide the module on the mobile view
		if ((isInstagram && isIphone) || (isFacebook && isIphone)) {
			this.hideInAPPBrowser = true;
		}
	},
	handleEnterView() {
		enterView({
			selector: [this.$refs.entry],
			offset: 1,
			enter(el) {
				el.classList.add('take-action__entry--active');
			},
			exit(el) {
				el.classList.remove('take-action__entry--active');
			},
		});

		if (hideAtAnchorLink) {
			enterView({
				selector: `#${hideAtAnchorLink}`,
				offset: 0,
				progress: (el, prog) => {
					this.$refs.entry.classList.toggle(
						'take-action__entry--active',
						!prog
					);
				},
			});
		}
	},
	scrollToTakeAction() {
		jump(this.$root, {
			duration: 400,
			offset: -100,
			a11y: true,
		});
	},
	getCount() {
		if (endpoint) {
			this.$store.aa
				.api(endpoint)
				.get()
				.json((response) => {
					if (response.success === true) {
						this.successful = true;
						this.petitionCount =
							response?.data?.num_signatures || response?.data?.num_sends;
					}
				});
		} else {
			this.petitionCount = null;
		}
	},
}));
